module.exports = __webpack_public_path__ + "static/media/nps_image_base.089ec2e6.svg";